// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__BWqNs","load1":"Spinner_load1__1BXDX","SpinnerSmall":"Spinner_SpinnerSmall__ZhgsV"};